import { Component, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { DocumentUploadService } from '../documentupload-service/document-upload.service';
import { FilePreviewHelper, FilePreviewState } from './file-preview.helper';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
  providers: [
    FilePreviewHelper
  ]
})
export class FilePreviewComponent extends BaseFpxFormComponent<FilePreviewHelper, FilePreviewState> {

  constructor(
    @Optional() _controlContainer: ControlContainer,
    _formBuilder: FormBuilder,
    private _router: Router,
    private _documentPreviewHelper:FilePreviewHelper,
    private _docUploadService: DocumentUploadService,
  ) {
    super(_formBuilder, _router, _controlContainer, _documentPreviewHelper);
  }

  protected doPreInit(): void {

  }

}
